/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum MetadataPlacement {
  Default = "DEFAULT",
  None = "NONE",
  OnTop = "ON_TOP",
  Below = "BELOW",
}
